// File: frontend/src/contentfulClient.js
import { createClient } from 'contentful';

// This client will automatically read your .env variables
export const client = createClient({
  space: process.env.REACT_APP_CONTENTFUL_SPACE_ID,
  accessToken: process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN,
});